import { Grid } from "@mui/material";
import FilterDatePicker from "components/FilterDatePicker";
import { startOfDay } from "date-fns";
import { useIntl } from "react-intl";

type EventStartDatePickerProps = {
  value?: Date;
  onChange: (value: Date | undefined) => void;
};

export default function EventStartDatePicker({
  value,
  onChange,
}: EventStartDatePickerProps) {
  const { formatMessage: t } = useIntl();

  const onChangeInternal = (date: Date | undefined) => {
    onChange(date ? startOfDay(date) : date);
  };

  return (
    <Grid item xs={12} sm={12} md={4}>
      <FilterDatePicker
        label={t({ id: "from" })}
        value={value}
        onChange={onChangeInternal}
      />
    </Grid>
  );
}
